import React, { useEffect } from "react";

export const Loader = () => {
    useEffect(() => {
    }, []);
    return (<div className="loading"></div>);
};